import { useQueryClient } from '@tanstack/react-query';
import { useAPI } from 'data/api';
import { MutationPayload } from 'src/hooks/query';
import { useSyncMutation } from 'src/hooks/useSyncMutation';

interface AutoJoinPayload {
  orgId: string;
  builderId: string;
}

export function useAutoJoinMutation() {
  const getAPI = useAPI();
  const queryClient = useQueryClient();

  return useSyncMutation({
    mutationKey: ['autoJoin'],
    mutationFn: async (payload: MutationPayload<AutoJoinPayload>) => {
      const api = await getAPI();
      const { orgId, builderId } = payload.data;

      return api.orgApi.addUserToOrg({
        orgId,
        addUserToOrgRequest: { builderId },
      });
    },
    options: {
      onSuccess: () => {
        // Invalidate queries that depend on user's org membership
        queryClient.invalidateQueries({ queryKey: ['myInfo'] });
        queryClient.invalidateQueries({ queryKey: ['orgInvites'] });
      },
    },
  });
}
